// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-login-credentials .password-input-wrapper {
  position: relative;
}
.fi-login-credentials .password-input-wrapper .toggle-input-type-button .mat-icon {
  font-size: 16px;
  color: var(--fi-color-filter-grey-light);
}
.fi-login-credentials .password-input-wrapper .caps-tooltip-wrapper {
  position: absolute;
  top: -6px;
  left: 0;
  width: calc(100% + 13px);
  height: 60px;
  z-index: -1;
}
.fi-login-credentials .password-input-wrapper .caps-tooltip-wrapper .info-icon-wrapper {
  width: 100%;
  height: 100%;
}
.fi-login-credentials .LoginHelpContainerLoginForgotPassword {
  position: relative;
  margin-top: -22px;
}
.fi-login-credentials .LoginHelpContainerLoginForgotPassword a:focus {
  outline: none;
}
.fi-login-credentials .fa {
  color: var(--fi-color-light);
}`, "",{"version":3,"sources":["webpack://./Source/app/authenticate/login/fi-login-credentials/fi-login-credentials.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;AAAR;AAEY;EACI,eAAA;EACA,wCAAA;AAAhB;AAGQ;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;AADZ;AAEY;EACI,WAAA;EACA,YAAA;AAAhB;AAII;EACI,kBAAA;EACA,iBAAA;AAFR;AAIQ;EACI,aAAA;AAFZ;AAMI;EACI,4BAAA;AAJR","sourcesContent":[".fi-login-credentials {\r\n    .password-input-wrapper {\r\n        position: relative;\r\n        .toggle-input-type-button {\r\n            .mat-icon {\r\n                font-size: 16px;\r\n                color: var(--fi-color-filter-grey-light);\r\n            }\r\n        }\r\n        .caps-tooltip-wrapper {\r\n            position: absolute;\r\n            top: -6px;\r\n            left: 0;\r\n            width: calc(100% + 13px);\r\n            height: 60px;\r\n            z-index: -1;\r\n            .info-icon-wrapper {\r\n                width: 100%;\r\n                height: 100%;\r\n            }\r\n        }\r\n    }\r\n    .LoginHelpContainerLoginForgotPassword {\r\n        position: relative;\r\n        margin-top: -22px;\r\n\r\n        a:focus {\r\n            outline: none;\r\n        }\r\n    }\r\n\r\n    .fa {\r\n        color: var(--fi-color-light);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
